import { render, staticRenderFns } from "./Enroll.vue?vue&type=template&id=015d31e0"
import script from "./Enroll.vue?vue&type=script&lang=js"
export * from "./Enroll.vue?vue&type=script&lang=js"
import style0 from "./Enroll.vue?vue&type=style&index=0&id=015d31e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports